export default class GroupRoomMemberRequestBuilder {
    constructor(instant) {
        if (instant) {
            this.data = instant.data;
        } else {
            this.data = {
                rooms: {},
                members: {},
            };
        }
    }

    addRoom(roomId) {
        let rooms = this.data.rooms;
        if (!rooms[roomId]) {
            rooms[roomId] = {
                memberLoginIds: [],
            };
        }
    }

    addMember(loginId) {
        let members = this.data.members;
        if (!members[loginId]) {
            members[loginId] = {};
        }
    }

    addMemberToRoom(roomId, loginId) {
        let room = this.data.rooms[roomId];
        if (room) {
            this.addMember(loginId);
            room.memberLoginIds.push(loginId);
        }
    }

    appendMemberUserId(loginId, userId) {
        let member = this.data.members[loginId];
        if (member) {
            member.userId = userId;
        }
    }

    updateMemberReadOnly(loginId, isReadOnly) {
        let member = this.data.members[loginId];
        if (member) {
            member.isReadOnly = isReadOnly;
        }
    }

    setMemberRole(loginId, role) {
        let member = this.data.members[loginId];
        if (member) {
            member.role = role;
        }
    }

    getAllMemberLoginIds() {
        let output = [];
        for (let [loginId, member] of Object.entries(this.data.members)) {
            output.push(loginId);
        }
        return output;
    }

    getRoomIds() {
        return Object.keys(this.data.rooms);
    }

    getRoomMember(roomId) {
        let output = [];
        let rooms = this.data.rooms;
        if (rooms[roomId]) {
            rooms[roomId].memberLoginIds.forEach((item) => {
                let member = this.data.members[item];
                output.push({
                    loginId: item,
                    userId: member.userId,
                });
            });
        }
        return output;
    }
    
    getRoomMemberLoingIds(roomId) {
        let rooms = this.data.rooms;
        if (rooms[roomId]) {
            return rooms[roomId].memberLoginIds;
        }
    }

    toServerFormat() {
        let output = [];
        let membersRef = this.data.members;
        for (let [roomId, room] of Object.entries(this.data.rooms)) {
            output.push({
                RoomId: roomId,
                Members: room.memberLoginIds.map((m) => {
                    return {
                        LoginId: m,
                        HashUserId: membersRef[m].userId,
                        IsReadOnly: membersRef[m].isReadOnly,
                        Role: membersRef[m].role
                    }
                })
            });
        }
        return output;
    }
}
